export type FontFamilyKey = 'inter' | 'montserrat' | 'system' | 'helvetica';
export type FontWeightKey = 'light' | 'regular' | 'semi-bold' | 'bold';

export interface WeightProfile {
	heading: number;
	body: number;
	button: number;
	caption: number;
}

export const FONT_STACKS: Record<FontFamilyKey, string> = {
	inter: '\'Inter\', -apple-system, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial, sans-serif',
	montserrat:
		'\'Montserrat\', -apple-system, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial, sans-serif',
	system: '-apple-system, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial, sans-serif',
	helvetica: '\'Helvetica Neue\', Helvetica, Arial, -apple-system, BlinkMacSystemFont, sans-serif'
};

export const WEIGHT_PROFILES: Record<FontWeightKey, WeightProfile> = {
	light: { heading: 500, body: 300, button: 400, caption: 300 },
	regular: { heading: 600, body: 400, button: 500, caption: 400 },
	'semi-bold': { heading: 700, body: 500, button: 600, caption: 400 },
	bold: { heading: 800, body: 600, button: 700, caption: 500 }
};

export const FONT_FAMILY_LABELS: Record<FontFamilyKey, string> = {
	inter: 'Inter',
	montserrat: 'Montserrat',
	system: 'System (San Francisco)',
	helvetica: 'Helvetica Neue'
};

export const FONT_WEIGHT_LABELS: Record<FontWeightKey, string> = {
	light: 'Light',
	regular: 'Regular',
	'semi-bold': 'Semi-Bold',
	bold: 'Bold'
};

export const getFontFamily = (key: FontFamilyKey): string => FONT_STACKS[key] ?? FONT_STACKS.inter;

export const getWeightProfile = (key: FontWeightKey): WeightProfile => WEIGHT_PROFILES[key] ?? WEIGHT_PROFILES.regular;
